import { Grid, Box, Typography, useTheme } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = [
  '我确认医生已向我解释：',
  '我的医疗状况以及我需要输血的原因。我理解这些风险，包括与我具体情况相关的风险。',
  '其他相关治疗选项及其相关风险。',
  '我的预后以及不进行此治疗的风险。',
  '即使治疗已在专业护理下进行，也无法保证治疗会改善我的状况。',
  '如果治疗过程中发生立即危及生命的事件，将会相应处理。',
];

const checks = [
  {
    label: '血液制品输血同意书 - 患者副本',
    key: 'consent.checked01',
  },
  {
    label: '消费者手册 - 谁需要血液？',
    key: 'consent.checked02',
  },
  {
    label: '输血 - 您和您的家人常见问题解答',
    key: 'consent.checked03',
  },
  {
    label: '血液成分 - 患者指南',
    key: 'consent.checked04',
  },
];

const contents2 = [
  '我能向医生提出问题并表达对我的病情、拟议治疗及其风险以及治疗选择的担忧。我的问题和担忧已得到讨论并令我满意地回答。',
  '我理解我有权在治疗开始前的任何时候改变主意，包括在签署此表格后，但最好是在与医生讨论后进行。',
];

const FContents = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="F. 患者同意書" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '30px',
                  whiteSpace: 'pre',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '30px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
      <Box sx={{ width: '98%', margin: '0px auto 0px 15px' }}>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '30px',
            whiteSpace: 'pre',
          }}
        >
          我已收到以下患者信息資料：
        </Typography>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ width: '98%', margin: '10px auto 24px auto' }}>
        {contents2.map((v, i) => {
          return (
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
                color: `${palette.primary.main}`,
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default FContents;
